import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { GridCellParams } from '@mui/x-data-grid'

import { CategoryIcon, Text } from '@mxenabled/mxui'

export const CategoryCell = (params: GridCellParams) => {
  const isTotal = params.id === 'total'

  return (
    <Stack alignItems="center" direction="row" role="rowheader" tabIndex={params.tabIndex}>
      {!isTotal && (
        <Box aria-hidden={true}>
          <CategoryIcon categoryGuid={params.row.top_level_category_guid} variant="twotone" />
        </Box>
      )}
      <Text bold={isTotal} sx={{ ml: 12 }} variant={isTotal ? 'body1' : 'body2'}>
        {params.row.category}
      </Text>
    </Stack>
  )
}
